import "./../css/Loading.css";

export default function Loader() {
    return (
        <div id="loader">
            <div id="shadow"></div>
            <div id="box"></div>
        </div>
    );
}
